import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './redux-store';

// These hooks can not be in the same file as the store, as that would create circular dependencies
export const useAppDispatch = () =>
  useDispatch<AppDispatch /* TODO: use AppDispatch from ./redux-store type when reducer actions are typed */>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
